import { FunctionComponent, PropsWithChildren } from "react";
import { RuleConfig } from "../../shared/settings/config";

interface AdditionalProps {
  ruleConfig: RuleConfig;
}

type RuleFactoryProps = AdditionalProps & PropsWithChildren<any>;

const RuleFactory: FunctionComponent<RuleFactoryProps> = ({ ruleConfig, ...props }) => {

  if (ruleConfig.render) {
    return ruleConfig.component
  } else {
    return null
  }
};

export default RuleFactory;
